export const PROPOSAL_BAR_BORDER_WIDTH_PX = 2;

/**
 * Visual invariant for every baseline/proposal CO2 bar:
 *
 * - the 2 px proposal (or baseline) color sits on the bar's outer edge;
 * - the 2 px, 10%-black line sits immediately inside it;
 * - the inner radius is the outer radius minus the 2 px inset, so the curves
 *   remain concentric;
 * - neither layer draws a bottom border.
 *
 * Keep these layers separate. Overlapping equal-width borders hide the color,
 * while reusing the outer radius for the inset border produces mismatched
 * corners.
 */
export const getProposalBarBorderSx = (
  color: string,
  outerTopRadius: string,
  innerTopRadius: string,
) => ({
  '&::before': {
    content: '""',
    position: 'absolute',
    top: PROPOSAL_BAR_BORDER_WIDTH_PX,
    right: PROPOSAL_BAR_BORDER_WIDTH_PX,
    bottom: 0,
    left: PROPOSAL_BAR_BORDER_WIDTH_PX,
    boxSizing: 'border-box',
    borderTop: `${PROPOSAL_BAR_BORDER_WIDTH_PX}px solid rgba(0,0,0,0.1)`,
    borderRight: `${PROPOSAL_BAR_BORDER_WIDTH_PX}px solid rgba(0,0,0,0.1)`,
    borderLeft: `${PROPOSAL_BAR_BORDER_WIDTH_PX}px solid rgba(0,0,0,0.1)`,
    borderRadius: innerTopRadius,
    pointerEvents: 'none',
    zIndex: 4,
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    boxSizing: 'border-box',
    borderTop: `${PROPOSAL_BAR_BORDER_WIDTH_PX}px solid ${color}`,
    borderRight: `${PROPOSAL_BAR_BORDER_WIDTH_PX}px solid ${color}`,
    borderLeft: `${PROPOSAL_BAR_BORDER_WIDTH_PX}px solid ${color}`,
    borderRadius: outerTopRadius,
    pointerEvents: 'none',
    zIndex: 3,
  },
});
